module.exports = __webpack_public_path__ + "f4993d043b44ff8f0cbb8a367cc73ed5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/japanese-restaurant-empty.png
// module id = 311
// module chunks = 0